/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/reviews'>.
 * /r/-хвост не-exact легаси (§3.2)
 */
import { createFileRoute, notFound } from '@tanstack/react-router';
import CacheDataRoute from '../../../CacheDataRoute';
import Reviews from '@routes/Reviews';
import { getQueryClient } from '../../../providers/query';
import {
  buildReviewsListParams,
  reviewsInfiniteQueryOptions
} from '@queries/index';
import { isContentNotFoundError } from '../../../api/contentNotFound';
import { assertValidListUrl } from '../../../ssrListParams';

export const Route = createFileRoute('/reviews/r/$')({
  /**
   * ЭТАП 2 — честный 404 несуществующей страницы отзывов
   * (/reviews/r/page/99999, в т.ч. с фильтрами /r/sort/Positive/page/N):
   * бэк (getReviewsAll) кидает CONTENT_NOT_FOUND через checkPageExists
   * (и checkPageNumber для page < 1) -> notFound() -> HTTP 404 + контент
   * /404 без редиректа. ensureInfiniteQueryData дедуплицируется с
   * root-префетчем (тот же ключ фильтров) — лишнего запроса нет.
   * page 1 не проверяем (пустой раздел — норма, как на бэке); клиентскую
   * навигацию не блокируем.
   */
  loader: async ({ location }) => {
    if (typeof window !== 'undefined') {
      return;
    }
    // Хвост /r/ обязан быть каноническим: чужие ключи, битые значения
    // и /r/page/1 — честный 404, см. src/ssrListParams.ts
    assertValidListUrl('reviews', location.pathname);
    const { params, page } = buildReviewsListParams(location.pathname);
    if (!Number.isFinite(page) || page === 1) {
      return;
    }
    const queryClient = getQueryClient();
    const options = reviewsInfiniteQueryOptions(params, page);
    // Префетч успел упасть раньше — ошибка уже в кэше, без второго запроса
    const settled = queryClient.getQueryState(options.queryKey);
    if (settled?.error) {
      if (isContentNotFoundError(settled.error)) {
        throw notFound();
      }
      return;
    }
    try {
      await queryClient.ensureInfiniteQueryData(options);
    } catch (error) {
      if (isContentNotFoundError(error)) {
        throw notFound();
      }
    }
  },
  component: () => <CacheDataRoute component={Reviews} path='/reviews' />
});
